var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * The step feed of a deep-mode investigation: one line per tool call, with a spinner while
 * it runs, a check when done and an amber retry icon when the call failed and the model was
 * asked to fix it. Open while the run is live, collapsed on a finished answer.
 */
var DeepSteps = /** @class */ (function (_super) {
    __extends(DeepSteps, _super);
    function DeepSteps() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expanded = null;
        return _this;
    }
    Object.defineProperty(DeepSteps.prototype, "isExpanded", {
        get: function () {
            return this.expanded === null ? this.live : this.expanded;
        },
        enumerable: false,
        configurable: true
    });
    DeepSteps.prototype.iconFor = function (step) {
        if (step.status === 'running')
            return 'fas fa-circle-notch fa-spin';
        if (step.status === 'retry')
            return 'fas fa-redo';
        return 'fas fa-check-circle';
    };
    __decorate([
        Prop({ type: Array, required: true })
    ], DeepSteps.prototype, "steps", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], DeepSteps.prototype, "label", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], DeepSteps.prototype, "live", void 0);
    DeepSteps = __decorate([
        Component
    ], DeepSteps);
    return DeepSteps;
}(Vue));
export default DeepSteps;
